import { Box, Container, Stack, Typography } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import { LanguageControl } from "@/components/i18n/LanguageControl";
import { GeoAnalyticsFooter } from "@/components/layout/GeoAnalyticsFooter";
import { ThemeModeControl } from "@/components/theme/ThemeModeControl";

export function PublicLayout() {
  const location = useLocation();
  const immersive = [
    "/entrar",
    "/sobre",
    "/cadastro",
    "/recuperar-senha",
    "/verificar-conta"
  ].includes(location.pathname);

  if (immersive) {
    return (
      <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
        <Outlet />
        <GeoAnalyticsFooter compact />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "background.default",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Container maxWidth="sm" sx={{ py: { xs: 3, sm: 6 } }}>
          <Stack spacing={4}>
            <Stack
              direction="row"
              spacing={2}
              sx={{ alignItems: "center", justifyContent: "space-between" }}
            >
              <Typography variant="h1" sx={{ fontSize: "1.5rem" }}>
                GeoAnalytics
              </Typography>
              <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                <LanguageControl />
                <ThemeModeControl />
              </Stack>
            </Stack>
            <Outlet />
          </Stack>
        </Container>
      </Box>
      <GeoAnalyticsFooter />
    </Box>
  );
}
